import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/prodajalci/")({
  beforeLoad: () => {
    throw redirect({ to: "/izdelki" });
  },
});
